import _ from 'lodash';

import { phoneTypeOptions as phoneTypeOptionsArray } from 'common-src/models/PatientPhoneNumber/constants';

export const phoneTypeOptions = _.map(phoneTypeOptionsArray, (option) => ({
  value: option,
  label: option,
}));
